import { useContext } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../services/contexts/AuthContext";
import { useCurrency } from "../services/contexts/CurrencyContext";
import firebase from "./firebase";
import { ProductImage } from "./ProductImage";

export const CatalogItem = ({
  id,
  name,
  img,
  price,
  type,
  owner,
  onDelete,
}) => {
  const { user } = useContext(AuthContext);
  const { formatPrice } = useCurrency();

  // Check if current user is owner or admin
  const isOwnerOrAdmin = () => {
    if (!user) return false;
    const userId = user.uid || user._delegate?.uid;
    const userEmail = user.email;
    return userId === owner || userEmail === 'stamsy.art@abv.bg';
  };

  // Handle delete product
  const handleDelete = async () => {
    if (window.confirm(`Сигурни ли сте, че искате да изтриете "${name}"?`)) {
      try {
        const db = firebase.firestore();
        await db.collection('Products').doc(id).delete();
        alert('Продуктът е изтрит успешно!');
        
        // Call parent's onDelete if provided, otherwise reload
        if (onDelete) {
          onDelete(id);
        } else {
          window.location.reload();
        }
      } catch (error) {
        console.error('Error deleting product:', error);
        alert('Грешка при изтриване на продукта. Моля, опитайте отново.');
      }
    }
  };

  // Същата карта като на началната страница (.sa-card от src/styles/theme.css).
  // Връзката обгръща снимката и текста, а копчетата на собственика стоят под
  // нея — вложен бутон вътре в <a> не е валиден и не се улучва с пръст.
  return (
    <article className="sa-card catalog-card">
      <Link to={`/catalog/${id}`} className="catalog-card-link">
        <div className="sa-media sa-media--cover">
          <ProductImage
            src={img}
            alt={name}
            ratio={1}
            sizes="(min-width: 1200px) 290px, (min-width: 768px) 33vw, 50vw"
            loading="lazy"
            decoding="async"
          />
        </div>
        <div className="sa-card-body">
          <p className="sa-name">{name}</p>
          <p className="sa-price">{formatPrice(price)}</p>
          <span className="catalog-card-more">Виж детайли →</span>
        </div>
      </Link>

      {isOwnerOrAdmin() && (
        <div className="catalog-card-admin">
          <Link to={`/catalog/${id}/edit`} className="sa-btn sa-btn--outline sa-btn--sm">
            Редактирай
          </Link>
          <button type="button" onClick={handleDelete} className="sa-btn sa-btn--sm catalog-card-delete">
            Изтрий
          </button>
        </div>
      )}
    </article>
  );
};
